import useAuction from '@/hooks/useAuction';
import useItemContext from '@/hooks/useItemContext';
import useOffers from '@/hooks/useOffers';
import React, { useState } from 'react';
import If from '@/components/util/IF';
import {
    ProductEcomAuctionBidStatus,
    ProductEcomButtons,
    ProductEcomBuyNowButton,
    ProductEcomCodeAndBadge,
    ProductEcomAuctionNotifications,
    ProductEcomProductTitle,
    ProductEcomPutOffer,
    ProductEcomNotifications,
    ProductEcomAuctionPromotion,
    ProductEcomSubscriberCode,
    ProductEcomItemVariants,
} from '@/components/ecommerce/product/ProductPage/ProductEcom';

type ProductEcomProps = {
    isEverythingLoaded: boolean;
    setShowShare: (val: boolean) => void;
    setShowBidding: (val: boolean) => void;
    setShowOffering: (val: boolean) => void;
};

const ProductEcom = (props: ProductEcomProps) => {
    const { isEverythingLoaded, setShowShare, setShowBidding, setShowOffering } = props;
    const { item } = useItemContext();
    const [currentDonationAmount, setCurrentDonationAmount] = useState<string | undefined>();
    const { offerPossible } = useOffers(item, true);
    const { hasAuction, loading, pickupOption, comingSoon } = useAuction(item, undefined, true);
    const hasAuctionFlag = hasAuction && isEverythingLoaded && !offerPossible;
    const showGreyBox = (hasAuctionFlag || comingSoon || item?.current_offer_transaction) && isEverythingLoaded;

    return (
        <div className="flex-col flex justify-center  max-w-full  w-full sm-tablet:!max-w-full  tablet:!max-w-[480px]  md:!max-w-[480px] mt-[40px] lg:mt-[0]">

            <ProductEcomCodeAndBadge isEverythingLoaded={isEverythingLoaded} />
            <ProductEcomProductTitle isEverythingLoaded={isEverythingLoaded} pickupOption={hasAuctionFlag && isEverythingLoaded ? pickupOption : undefined} />
            <ProductEcomItemVariants />

            <If condition={showGreyBox}>
                <div className="md:max-w-[480px] md:mx-0 mx-auto w-full sm-tablet:max-w-[unset] bg-grey16 rounded-[10px] p-[20px] mb-[40px]">
                    <If condition={!item?.current_offer_transaction}>
                        <ProductEcomAuctionNotifications />
                    </If>
                    <ProductEcomAuctionBidStatus />
                    <ProductEcomAuctionPromotion setCurrentDonationAmount={setCurrentDonationAmount} />
                    <ProductEcomSubscriberCode />
                </div>
            </If>

            <ProductEcomNotifications />
            <ProductEcomPutOffer isEverythingLoaded={isEverythingLoaded} onShowOffering={setShowOffering} />
            <ProductEcomBuyNowButton donationAmount={currentDonationAmount} hasAuctionFlag={hasAuctionFlag} />
            <ProductEcomButtons
                isEverythingLoaded={isEverythingLoaded}
                hasAuctionFlag={hasAuctionFlag}
                loading={loading}
                showShare={() => setShowShare(true)}
                showBidding={() => setShowBidding(true)}
            />

        </div>
    );
};

export default ProductEcom;
